var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationMarkCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 7.5,
    fill: "#FF7F40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 9.39844H6.99609L6.69141 3.43359H8.31445L8.01562 9.39844ZM6.62109 11.2676C6.62109 10.9785 6.69727 10.7598 6.84961 10.6113C7.00195 10.459 7.21875 10.3828 7.5 10.3828C7.77734 10.3828 7.99023 10.4609 8.13867 10.6172C8.28711 10.7734 8.36133 10.9902 8.36133 11.2676C8.36133 11.5449 8.28516 11.7656 8.13281 11.9297C7.98438 12.0898 7.77344 12.1699 7.5 12.1699C7.22266 12.1699 7.00586 12.0918 6.84961 11.9355C6.69727 11.7793 6.62109 11.5566 6.62109 11.2676Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkCircle);
export default __webpack_public_path__ + "static/media/exclamation_mark_circle.d468d2fad5f8976bede592112b3d3bf8.svg";
export { ForwardRef as ReactComponent };